import DataEnrichment from './dataEnrichment'

if (!FollozeState.initialState.lead.account_domain) {
  DataEnrichment(FollozeState.initialState.data_service_configuration)
}
